import React from "react";
import '../styles/style.css';
import { skillGroups } from '../data/portfolio';

function Skills() {
    return (
        <section id="skills-section" className="section-wrap skills-section">
            <div className="section-heading">
                <p className="eyebrow">Capability map</p>
                <h2>Systems, data, and delivery capability.</h2>
            </div>

            <div className="skills-grid">
                {skillGroups.map((group) => (
                    <article className="skill-card" key={group.title}>
                        <div className="skill-card-header">
                            <h3>{group.title}</h3>
                            <p>{group.summary}</p>
                        </div>
                        <div className="skill-tags primary-tags" aria-label={`${group.title} primary skills`}>
                            {group.primary.map((skill) => (
                                <span key={skill}>{skill}</span>
                            ))}
                        </div>
                        <div className="skill-tags secondary-tags" aria-label={`${group.title} supporting skills`}>
                            {group.secondary.map((skill) => (
                                <span key={skill}>{skill}</span>
                            ))}
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default Skills;
